module.exports = __webpack_public_path__ + "img/conny-stage2-sulking.dfdcfdae.png";